import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-heading font-bold text-foreground mb-6">Privacy Policy</h1>
        <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
          <p>
            AA Innovation values your privacy. This page explains what information we collect, how we use it, and the
            choices you have about your data.
          </p>
          <p>
            We collect information you submit through forms and basic technical information needed to operate and
            secure this website. We do not sell personal information.
          </p>
          <p>
            To request updates or deletion of your submitted information, contact us using the details provided on our
            contact page.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
